import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e21feed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "jobWrapper d-flex flex-row"
}
const _hoisted_3 = { class: "jobId" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "whole-job" }
const _hoisted_6 = { class: "jobContent" }
const _hoisted_7 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "editswitch"
}, "Enable Editing", -1))
const _hoisted_9 = {
  key: 1,
  class: "job-header"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 2,
  class: "job-details"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "row py-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Priority : ", -1))
const _hoisted_18 = { class: "col col-8" }
const _hoisted_19 = { class: "row py-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Created By : ", -1))
const _hoisted_21 = {
  key: 0,
  class: "col col-8"
}
const _hoisted_22 = { class: "row py-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Start Date : ", -1))
const _hoisted_24 = { class: "col col-8" }
const _hoisted_25 = { class: "row py-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " End Date : ", -1))
const _hoisted_27 = { class: "col col-8" }
const _hoisted_28 = { class: "row py-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createTextVNode(" Man Hours :"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(HH/MM/SS) ")
], -1))
const _hoisted_30 = { class: "col col-8" }
const _hoisted_31 = {
  key: 0,
  class: "row py-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Total Cost : ", -1))
const _hoisted_33 = { class: "col col-8" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = { class: "row actionButtons" }
const _hoisted_36 = {
  key: 1,
  class: "btn btn-primary",
  disabled: ""
}
const _hoisted_37 = {
  key: 2,
  class: "alert alert-success rounded mx-2",
  disabled: ""
}
const _hoisted_38 = {
  key: 3,
  class: "alert alert-danger rounded mx-2",
  disabled: ""
}
const _hoisted_39 = { class: "task-table" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_44 = [
  _hoisted_43
]

import Modal from '@/components/Modal.vue';
import TaskList from '@/components/TaskList.vue';
import DateTimeBadge from '@/components/DateTimeBadge.vue';
import UserBadge from '@/components/UserBadge.vue';
import { useOpsSupplementStore } from '@/stores/OpsSupplement';
import { useJobStore } from '@/stores/Jobs';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { storeToRefs } from 'pinia';
import { computed, ref, watch, onMounted, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { Job, Task, JobPriority } from '@/types/Ops'
import { fetchJobDetails } from '@/api/api';

enum SaveState {
  NoChanges = 0,
  Changed = 1,
  Saving = 2,
  SaveFailed = 3,
  Saved = 4
}

export default /*#__PURE__*/_defineComponent({
  __name: 'JobView',
  setup(__props) {

const editState = ref(false);
const jobStore = useJobStore();
const isLoadingJobs = computed(() => jobStore.isLoadingJobs);
const employeeStore = useEmployeeStore();
const { employees } = storeToRefs(employeeStore);
const opsSupp = useOpsSupplementStore();
const { work_centers } = storeToRefs(opsSupp);
const route = useRoute();
const jobId = ref(parseInt(route.params.id as string));
const userStore = useEmployeeStore();
const currentUser = computed(() => userStore.currentUser);
const createdById = computed(() => job.value?.created_by ?? -1);

// console.log(route.params);

const job = computed(() => {
  if (jobStore.isLoadingJobs) {
    return undefined;
  }
  return jobStore.getJobById(jobId.value);
});

const saved = ref<SaveState>(SaveState.NoChanges);

function truncateMilliseconds(durationStr) {
  return durationStr ? durationStr.split('.')[0] : '00:00:00';
}

watch(() => job, (nextJob, lastJob) => {
  if (lastJob.value != undefined) saved.value = SaveState.Changed;
}, { deep: true });

watch(() => route.params, (nextParam, lastParam) => {
  jobId.value = parseInt(nextParam.id as string);
});


const priorityLabel = computed(() => {
  switch (job.value?.priority) {
    case JobPriority.Low:
      return 'Low';
    case JobPriority.Medium:
      return 'Medium';
    case JobPriority.High:
      return 'High';
    default:
      return 'Not Set';
  }
});

onMounted(async () => {
  if (!jobStore.all_jobs?.length) {
    jobStore.getAllJobs();
  }
  try {
    const jobDetails = await fetchJobDetails(jobId.value);
    // console.log("Fetched Job Details in JobView:", jobDetails);
    jobStore.updateJob(jobDetails);
  } catch (error) {
    console.error('Error fetching job details:', error);
  }
});

const save = () => {
  editState.value = false;
  saved.value = SaveState.Saving;
  jobStore.saveJob(jobId.value)
    .then(() => {
      saved.value = SaveState.Saved;
    })
    .catch(() => {
      editState.value = true;
      saved.value = SaveState.SaveFailed;
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(jobStore).isLoadingJobs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(job.value?.id + " |"), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_unref(employeeStore).currentUser.user?.is_superuser || (_unref(employeeStore).currentUser.user?.is_staff && !_unref(employeeStore).currentUser.user?.is_superuser))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      id: "editswitch",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editState).value = $event))
                    }, null, 512), [
                      [_vModelCheckbox, editState.value]
                    ]),
                    _hoisted_8
                  ]))
                : _createCommentVNode("", true),
              (job.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h1", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "job-name-input",
                          disabled: !editState.value,
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((job.value.name) = $event))
                        }, null, 8, _hoisted_11), [
                          [_vModelText, job.value.name]
                        ])
                      ]),
                      _hoisted_12,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "job-description-textarea",
                        disabled: !editState.value,
                        oninput: "this.style.height = \"\";this.style.height = this.scrollHeight + \"px\"",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((job.value.description) = $event))
                      }, null, 8, _hoisted_13), [
                        [_vModelText, job.value.description]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (job.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("b", null, _toDisplayString(priorityLabel.value), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        (job.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(UserBadge, { "user-id": createdById.value }, null, 8, ["user-id"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(DateTimeBadge, {
                            time: job.value?.started
                          }, null, 8, ["time"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(DateTimeBadge, {
                            time: job.value?.completed
                          }, null, 8, ["time"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, _toDisplayString(truncateMilliseconds(job.value?.total_active_duration)), 1)
                      ]),
                      (_unref(employeeStore).currentUser.user?.is_superuser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, " $" + _toDisplayString(job.value?.total_labor_cost), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_34
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_35, [
                (saved.value === SaveState.Changed || saved.value === SaveState.SaveFailed)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-primary customSaveButton",
                      onClick: save
                    }, "Save"))
                  : _createCommentVNode("", true),
                (saved.value === SaveState.Saving)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_36, "Saving..."))
                  : _createCommentVNode("", true),
                (saved.value === SaveState.Saved)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Saved"))
                  : _createCommentVNode("", true),
                (saved.value === SaveState.SaveFailed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Save Failed"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_39, [
                (_unref(employeeStore).currentUser.user?.is_superuser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createVNode(TaskList, {
                        tasks: job.value.tasks,
                        visibleColumns: ['id', 'name', 'description', 'started', 'concluded', 'total_active_duration', 'labor_cost', 'assigned', 'actions']
                      }, null, 8, ["tasks"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(employeeStore).currentUser.user?.is_staff && !_unref(employeeStore).currentUser.user?.is_superuser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createVNode(TaskList, {
                        tasks: job.value.tasks,
                        visibleColumns: ['id', 'name', 'description', 'started', 'concluded', 'total_active_duration', 'assigned', 'actions']
                      }, null, 8, ["tasks"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
  ]))
}
}

})